import { useState } from "react";
import { database } from '../../config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate} from "react-router-dom";

function LoginPage() {
  const history  = useNavigate();
  const [username, setUserName] = useState('');
  const [password, setpassword] = useState('');
  
  function login(ev) {
    ev.preventDefault();
    signInWithEmailAndPassword(database, username, password).then((data)=>{
        console.log(data, "authData");
        history('/admin/dashboard')
    }).catch(err=>{
        alert(err.code)
    })
    console.log("user details", username, password)
  }

  return (
    <form className="login-page aboutTop" onSubmit={login}>
      <div className="form">
        <h3 className="trekName loginTop">ADMIN LOGIN</h3>
        <input type="text" placeholder="USERNAME (Try test@gmail.com)" className="username" value={username} onChange={ev => setUserName(ev.target.value)} required/>
        <input type="password" placeholder="PASSWORD (Try test123)" className="password" value={password} onChange={ev => setpassword(ev.target.value)} required/>
        <button type="submit">LOGIN</button>
      </div>
    </form>
  )
}

export default LoginPage